import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  Nav,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Badge
} from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';

class Header extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <header className="app-header navbar">
        <NavbarBrand href="#"></NavbarBrand>
        <Nav className="ml-auto" navbar style={{marginRight: 1 + '%'}}>
          <HeaderDropdown/>
        </Nav>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js